import { AuctionLotToUpdate } from '@/staff/domain/exclusive/AuctionLotToUpdate';

export interface BackendAuctionLotToUpdate {
  number?: number;
}

export const fromAuctionLotToUpdate = (auctionLot: AuctionLotToUpdate): BackendAuctionLotToUpdate => ({
  number: auctionLot.number.orElseUndefined(),
});
